import router from '../router';
import multiguard from 'vue-router-multiguard';

function redirectToLastTab(lastTabKey, parentPath) {
  return (to, from, next) => {
    const lastTab = localStorage.getItem(lastTabKey);

    const isChildRoute = to.fullPath !== parentPath && to.fullPath.startsWith(parentPath + '/');

    if (!isChildRoute && lastTab && to.fullPath === parentPath && lastTab !== to.fullPath) {
      next(lastTab);
    } else {
      next();
    }
  };
}

function mergeGuards(route, additionalGuards) {
  if (route.beforeEnter) {
    route.beforeEnter = multiguard([route.beforeEnter, ...additionalGuards]);
  } else {
    route.beforeEnter = multiguard(additionalGuards);
  }
  return route;
}

export { redirectToLastTab, mergeGuards };
